import React, { useMemo, memo } from "react"
import { BotaoAlternarTema } from "../tema/BotaoAlternarTema"

type MenuItem = {
  permissao: boolean
  id: string
  label: string
  accessKey?: string
  title?: string
  onClick: () => void
  grupo: 'vendas' | 'pesquisas' | 'usuario'
  customClass?: string
}

type MenuGrupo = MenuItem['grupo']

export type MenuPrincipalProps = {
    permitirVisualizarVendas: boolean
    permitirVisualizarOutrasSaidas: boolean
    permitirVisualizarTransferencias: boolean
    permitirVisualizarPesquisarOrcamento: boolean
    permitirVisualizarCotacoesPerdidas: boolean
    permitirVisualizarPesquisarProduto: boolean
    permitirVisualizarPesquisarCliente: boolean
  permitirVisualizarPesquisarMetasBonus: boolean // PA 474948
    permitirVisualizarAtendimentoCliente: boolean
    permitirVisualizarUnificacaoDeOrcamentos: boolean // 427169
    permitirVisualizarComissaoPorClassificacao: boolean // 482087
    permitirVisualizarOrdemProducao: boolean
    permitirVisualizarDesdobramento: boolean
    nomeUsuario: string
    onRenderizarVenda: (tipoOrcamento: string) => void // 427169
    // onRenderizarOutrasSaidas: () => void
    // onRenderizarTransferencia: () => void
    onRenderizarPesquisaOrcamento: () => void
    onRenderizarCotacoesPerdidas: () => void
    onRenderizarPesquisaProdutos: () => void
    onRenderizarPesquisaClientes: () => void
    onRenderizarAtendimentoCliente: () => void
    onRenderizarUnificacaoDeOrcamentos: () => void // 427169
  onRenderizarPesquisaMetasBonus: () => void // PA 474948
    onRenderizarDesdobramento: () => void
    onRenderizarOrdemProducao: () => void
    onRenderizarComissaoPorClassificacao: () => void // 482087
    onRenderizarSair: () => void
}

const MenuLink = memo(({ item }: { item: MenuItem }) => (
  <a
    href="#"
    className={`_block _py-[8px] _px-[15px] _cursor-pointer hover:_bg-[#eeeeee] ${item.customClass || ''}`}
    accessKey={item.accessKey}
    title={item.title}
    onClick={(e) => {
      e.preventDefault()
      item.onClick()
    }}
    id={item.id}
  >
    {item.label}
  </a>
))

export const MenuPrincipal = memo((props: MenuPrincipalProps) => {
  const {
    permitirVisualizarVendas,
    permitirVisualizarOutrasSaidas,
    permitirVisualizarTransferencias,
    permitirVisualizarPesquisarOrcamento,
    permitirVisualizarCotacoesPerdidas,
    permitirVisualizarPesquisarProduto,
    permitirVisualizarPesquisarCliente,
    permitirVisualizarAtendimentoCliente,
    permitirVisualizarUnificacaoDeOrcamentos,
    permitirVisualizarComissaoPorClassificacao,
    permitirVisualizarOrdemProducao,
    permitirVisualizarDesdobramento,
    nomeUsuario,
    onRenderizarVenda,
    onRenderizarPesquisaOrcamento,
    onRenderizarCotacoesPerdidas,
    onRenderizarPesquisaProdutos,
    onRenderizarPesquisaClientes,
    onRenderizarAtendimentoCliente,
    onRenderizarUnificacaoDeOrcamentos,
    onRenderizarDesdobramento,
    onRenderizarOrdemProducao,
    onRenderizarComissaoPorClassificacao,
    onRenderizarSair
  } = props

  const menuItems = useMemo<MenuItem[]>(() => [
    {
      permissao: permitirVisualizarVendas,
      id: 'MenuPrincipal_OrcamentoVenda',
      label: 'Venda',
      accessKey: '!',
      title: 'Tecla atalho[!]',
      onClick: () => onRenderizarVenda("VENDA"),
      grupo: 'vendas'
    },
    {
      permissao: permitirVisualizarOutrasSaidas,
      id: 'MenuPrincipal_OrcamentoOutrasSaidas',
      label: 'Outras Saídas',
      accessKey: '#',
      title: 'Tecla atalho [#]',
      onClick: () => onRenderizarVenda("OUTRAS_SAIDAS"),
      grupo: 'vendas'
    },
    {
      permissao: permitirVisualizarTransferencias,
      id: 'MenuPrincipal_OrcamentoTransferencia',
      label: 'Transferência',
      accessKey: '$',
      title: 'Tecla atalho [$]',
      onClick: () => onRenderizarVenda("TRANSFERENCIA"),
      grupo: 'vendas'
    },
    {
      permissao: permitirVisualizarPesquisarOrcamento,
      id: 'MenuPrincipal_PesquisaOrcamento',
      label: 'Pesquisa Orçamento',
      accessKey: '&',
      title: 'Tecla atalho [&]',
      onClick: onRenderizarPesquisaOrcamento,
      grupo: 'pesquisas',
      customClass: '_border-t-[1px] _border-[#eeeeee]'
    },
    {
      permissao: permitirVisualizarCotacoesPerdidas,
      id: 'MenuPrincipal_CotacoesPerdidas',
      label: 'Cotações Perdidas',
      onClick: onRenderizarCotacoesPerdidas,
      grupo: 'pesquisas'
    },
    {
      permissao: permitirVisualizarPesquisarProduto,
      id: 'MenuPrincipal_PesquisaProdutos',
      label: 'Pesquisa Produtos',
      onClick: onRenderizarPesquisaProdutos,
      grupo: 'pesquisas'
    },
    {
      permissao: permitirVisualizarPesquisarCliente,
      id: 'MenuPrincipal_PesquisaClientes',
      label: 'Pesquisa Clientes',
      onClick: onRenderizarPesquisaClientes,
      grupo: 'pesquisas'
    },
    {// PA 474948
      permissao: props.permitirVisualizarPesquisarMetasBonus,
      id: 'MenuPrincipal_PesquisaMetasBonus',
      label: 'Metas e Bônus',
      onClick: props.onRenderizarPesquisaMetasBonus,
      grupo: 'pesquisas'
    },
    {
      permissao: permitirVisualizarAtendimentoCliente,
      id: 'MenuPrincipal_AtendimentoCliente',
      label: 'Atendimento Cliente',
      onClick: onRenderizarAtendimentoCliente,
      grupo: 'pesquisas'
    },
    {
      permissao: permitirVisualizarUnificacaoDeOrcamentos,
      id: 'MenuPrincipal_UnificacaoDeOrcamentos',
      label: 'Unificação de Orçamentos',
      onClick: onRenderizarUnificacaoDeOrcamentos,
      grupo: 'pesquisas'
    },
    {
      permissao: permitirVisualizarDesdobramento,
      id: 'MenuPrincipal_Desdobramento',
      label: 'Desdobramento',
      onClick: onRenderizarDesdobramento,
      grupo: 'pesquisas'
    },
    {
      permissao: permitirVisualizarOrdemProducao,
      id: 'MenuPrincipal_OrdemProducao',
      label: 'Ordem de Produção',
      title: 'Veja parâmetro: Utiliza controle de produção?',
      onClick: onRenderizarOrdemProducao,
      grupo: 'pesquisas'
    },
    { // 482087
      permissao: permitirVisualizarComissaoPorClassificacao,
      id: 'MenuPrincipal_ComissaoPorClassificacao',
      label: 'Comissão por Classificação',
      title: 'Veja parâmetro: Utiliza cálculo de comissão por classificação de vendedor e faixa de desconto',
      onClick: onRenderizarComissaoPorClassificacao,
      grupo: 'pesquisas'
    },
    {
      permissao: !!nomeUsuario,
      id: 'MenuPrincipal_Sair',
      label: `Sair [${nomeUsuario}]`,
      onClick: onRenderizarSair,
      grupo: 'usuario',
      customClass: '_border-t-[1px] _border-[#eeeeee]'
    }
  ], [
    permitirVisualizarVendas,
    permitirVisualizarOutrasSaidas,
    permitirVisualizarTransferencias,
    permitirVisualizarPesquisarOrcamento,
    permitirVisualizarCotacoesPerdidas,
    permitirVisualizarPesquisarProduto,
    permitirVisualizarPesquisarCliente,
    permitirVisualizarAtendimentoCliente,
    permitirVisualizarUnificacaoDeOrcamentos,
    permitirVisualizarComissaoPorClassificacao,
    permitirVisualizarOrdemProducao,
    permitirVisualizarDesdobramento,
    nomeUsuario,
    onRenderizarVenda,
    onRenderizarPesquisaOrcamento,
    onRenderizarCotacoesPerdidas,
    onRenderizarPesquisaProdutos,
    onRenderizarPesquisaClientes,
    onRenderizarAtendimentoCliente,
    onRenderizarUnificacaoDeOrcamentos,
    onRenderizarDesdobramento,
    onRenderizarOrdemProducao,
    onRenderizarComissaoPorClassificacao,
    onRenderizarSair
  ])

  const menuItemsPorGrupo = useMemo<Record<MenuGrupo, MenuItem[]>>(() => ({
    vendas: menuItems.filter(item => item.grupo === 'vendas' && item.permissao),
    pesquisas: menuItems.filter(item => item.grupo === 'pesquisas' && item.permissao),
    usuario: menuItems.filter(item => item.grupo === 'usuario' && item.permissao)
  }), [menuItems])

  const renderGrupo = (grupo: MenuGrupo) => (
    <div className={grupo === 'usuario' ? '_border-t-[1px] _border-[#eeeeee]' : ''}
      id={`MenuPrincipal_Grupo_${grupo}`}
    >
      {menuItemsPorGrupo[grupo].map((item) => (
        <MenuLink 
          key={item.id} 
          item={item} 
        />
      ))}
    </div>
  )

  return (
    <>
      <span className="_py-[8px] _px-[15px] _text-[24px] _text-[#dbdbdb]"
        id="MenuPrincipal_TituloVendas"
      >Vendas</span>
      {renderGrupo('vendas')}
      {renderGrupo('pesquisas')}
      {renderGrupo('usuario')}

      {/* Controle de tema no rodape do drawer. Fica fora da lista de itens de
          proposito: e preferencia visual, nao navegacao. O posicionamento se
          ancora em `.sidebar` (position: fixed, ver
          assets/sonatra-jquery-sidebar/css/sidebar.css), entao o botao desliza
          junto com o drawer ao abrir/fechar.

          A classe (em vez das utilitarias `_absolute _bottom-[12px]` que
          estavam aqui) e necessaria porque a barra precisa de FUNDO OPACO e de
          reservar espaco no fim da lista: em tela baixa os itens do menu rolam
          por baixo dela e apareciam atras do rotulo "Tema Escuro". Regras em
          Content/estilo.css. */}
      <div className="menu-principal-barra-tema">
        <BotaoAlternarTema comRotulo id="MenuPrincipal_AlternarTema" />
      </div>
    </>
  )
})
